<template>
  <div class="header">
    <div class="logo">
        <a href="/"><p class="graviaguas"><span>G</span>RAVI ÁGUAS</p></a>
    </div>
    <div class="menu">
      <ul>
        <li><router-link to="/" exact-active-class="active">Início</router-link></li>
        <li><router-link to="/fonts" exact-active-class="active">Fontes</router-link></li>
        <li><router-link to="/legislation" exact-active-class="active">Legislação</router-link></li>
        <li><router-link to="/productsList" exact-active-class="active">Produtos</router-link></li>
        <li><router-link to="/contact" exact-active-class="active">Contato</router-link></li>
        <li v-if="showConfiguration" class="configuration" @click="menu()">
          <i class="fas fa-user-cog"></i>
            <span class="badge bg-warning text-dark counter" :style="{ display: counter ? 'inline' : 'none' }">
              {{ counter }}
            </span>
        </li>
      </ul>
    </div>
    <div class="menu-configuration" v-if="showMenu">
      <div class="menu-users" @click="$router.push({ name: 'users' }).catch(err => {}); showMenu = false">
        Constrole de Usuários
      </div>
      <div class="products" @click="$router.push({ name: 'products' }).catch(err => {}); showMenu = false">
        Cadastro de Produtos
      </div>
      <div class="requests" @click="$router.push({ name: 'requests' }).catch(err => {}); showMenu = false">
        Pedidos de Venda
      </div>
      <div class="adverts" @click="$router.push({ name: 'adverts' }).catch(err => {}); showMenu = false">
        Anúncios
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutHeader',
  data: () => ({
    showMenu: false,
    showConfiguration: false,
    counter: ''
  }),
  methods: {
    menu () {
      this.showMenu = !this.showMenu
      if (this.showMenu) {
        this.closeMenu()
      }
    },
    closeMenu () {
      setTimeout(() => {
        this.showMenu = false
      }, 4000)
    },
    counterRequests () {
      this.ref = this.$firebase.database().ref('parameters/counter')
        .on('value', (data) => {
          this.counter = data.val()
          console.log(this.counter)
        })
    }
  },
  created () {
    this.$root.$on('Admin::show', () => { this.showConfiguration = true })
    this.$root.$on('Admin::hide', () => { this.showConfiguration = false })

    this.counterRequests()
  }
}
</script>

<style lang="scss" scoped>
  .header {
    height: 80px;
    box-shadow: 0px 3px 3px 0px #b0b0b0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 40px;
    padding-right: 40px;
    .logo {
      margin-top: 15px;
      .graviaguas {
          font-family: 'Poppins', sans-serif;
          font-size: 24px;
          color: #1b9bff;
          font-weight: 400;
          letter-spacing: 1px;
          span {
            background-color: #1b9bff;
            border-radius: 5px;
            color: #e7e7e7;
            font-size: 32px;
            margin-right: 5px;
            padding: 0px 12px;
          }
      }
    }
    .menu {
      margin-top: 15px;
    }
    .menu ul li {
        display: inline-block;
    }
    .menu ul li .counter {
      position: relative;
      bottom: 10px;
      color: #ffffff;
      font-size: 11px;
    }
    .menu ul li a, .configuration {
      font-size: 18px;
      padding: 7px 15px;
      margin-left: 5px;
      border-radius: 3px;
      color: #1b9bff;
      transition: .4s;
      &:hover {
        background-color: #1b9bff;
        color: #ffffff;
        cursor: pointer;
      }
    }
    .menu-configuration {
      position: absolute;
      right: 40px;
      top: 60px;
      transition: .4s;
      z-index: 1000;
      div {
        padding: 5px 30px;
        background-color: #1b9bff;
        color: #ffffff;
        &:hover {
          background-color: #028af1;
          cursor: pointer;
        }
      }
    }
  }
  .active {
    background-color: #1b9bff;
    color: #ffffff !important;
  }

  // PARA NÃO SAIR NO FUNDO DA IMPRESSAO ERRO DO CHROME
  @media print {
      .header {
      display: none !important;
    }
  }
</style>
